import React from "react";
import "./DeveloperCard.css";

export default function DeveloperCard({ name, imgUrl, quote }) {
  return (
    <div className="devCardWrapper">
      <div className="devCardImgWrapper">
        <img className="devCardImg" alt={name} src={imgUrl}></img>
        <h3 className="devCardName"> {name}</h3>
      </div>
      <p className="devCardQuote">{quote}</p>
    </div>
  );
}
